import { Store } from 'effector';
import { styled } from 'linaria/react';
import { useStore } from 'effector-react';
import React, { FC, useEffect } from 'react';

import { Group } from 'src/domain/group';
import { GroupCard } from 'src/ui/molecules/group-card';
import { Pagination } from 'src/ui/molecules/pagination';
import { FetchCollectionResponse } from 'src/domain/response-collection';
import { FetchGroupsEffect, MakeGroupFavoriteParams } from 'src/store/groups-collection.store';

const Grid = styled.div`	
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	column-gap: 16px;
	row-gap: 16px;
	max-width: var(--layout-width);
	width: 100%;
	margin-left: auto;
	margin-right: auto;
	
	@media (max-width: 600px) {
		grid-template-columns: repeat(2, 1fr);
	}
`;

type GroupsGridProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
	groups$: Store<FetchCollectionResponse<Group> | null>;
	fetchGroupsFx: FetchGroupsEffect;
	onFavorite: (payload: MakeGroupFavoriteParams) => void;
};

export const GroupsGrid: FC<GroupsGridProps> = (props) => {
	const { children, groups$, fetchGroupsFx, onFavorite, ...rest } = props;

	const groups = useStore(groups$);

	useEffect(() => {
		fetchGroupsFx({ page: 0 });
	}, []);

	return (
		<>
			<Grid {...rest}>
				{groups?.data.map(item => (
					<GroupCard
						onFavorite={onFavorite}
						group={item}
						key={item.id}
					/>
				))}
			</Grid>
			{groups !== null && groups.data.length > 0 && <Pagination
				page={groups.meta.page}
				total={groups.meta.total}
				onPaginated={page => {
					fetchGroupsFx({ page });
				}}
			/>}
		</>
	);
};
